import { StorageKey } from '@nu-art/thunderstorm-frontend/index';
export const StorageKey_hideNegative = new StorageKey('storage-key__hide-negative');
export const StorageKey_devMode = new StorageKey('storage-key__dev-mode');
export const StorageKey_EnableKickstart = new StorageKey('storage-key__enable-kickstart');
export const StorageKey_NumberOfKickstartQuestions = new StorageKey('storage-key__number-of-kickstart-questions');
export const StorageKey_ShowOrderSetProtocols = new StorageKey('storage-key__show-order-set-protocols');
//# sourceMappingURL=storage-keys.js.map